SET_DIALOG_OVERLAY_CLOSE